export const baseUrl = "/linkme_api/linkme_v1/admin"
